var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecording = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 10.213,
  fill: "#DB011C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#AB0216",
  fillRule: "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20m0-3.83c8.93 0 16.17-7.24 16.17-16.17S28.93 3.83 20 3.83 3.83 11.07 3.83 20 11.07 36.17 20 36.17",
  clipRule: "evenodd"
})));
export default SvgRecording;